import { render, staticRenderFns } from "./AdminUploaderComponent.vue?vue&type=template&id=1bd77464&"
import script from "./AdminUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
export * from "./AdminUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./AdminUploaderComponent.vue?vue&type=style&index=0&id=1bd77464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports